import { useToast } from "@codat/orchard-ui";

const maxLength = 100;

export const useCopyToClipboard = (): ((
  label: string,
  value: string
) => Promise<void>) => {
  const { addToast } = useToast();

  return async (label: string, value: string) => {
    await navigator.clipboard.writeText(value);
    const displayLabel =
      label.length > maxLength ? label.slice(0, maxLength) + "..." : label;

    addToast({
      message: `${displayLabel} copied to clipboard`,
      variant: "info",
    });
  };
};
